import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, RouterProvider, createBrowserRouter } from 'react-router-dom';
import SignIn from './componnets/SignIn';
import SignUp from './componnets/SignUp';
import PrivacyPolicy from './componnets/PrivacyPolicy';
import Home from './componnets/Home';

const root = ReactDOM.createRoot(document.getElementById('root'));

// const myRouter = createBrowserRouter([
//     { path: "/", Component: SignIn },
//     { path: "home", Component: Home  },
//     { path: "signup", Component: SignUp },
//     { path: "signin", Component: SignIn },
   
//   ]);

  root.render(
  

<BrowserRouter > 
    <App />
</BrowserRouter>
 
    
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
